import isEqual from 'lodash/isEqual';
import React from 'react';
import { useSelector } from 'react-redux';

import { Hierarchy } from 'common/visualizations/vif';
import { getTableHierarchies } from 'common/authoring_workflow/selectors/vifAuthoring';
import { AuthoringWorkflowState } from 'common/authoring_workflow/reducers/types';
import AddHierarchyLink from './components/AddHierarchyLink';
import { TableHierarchyGroupings } from '../TableHierarchyGroupings';

export const TableHierarchySelector = (): JSX.Element => {
  const tableHierarchies: Hierarchy[] = useSelector((state: AuthoringWorkflowState) => {
    return getTableHierarchies(state.vifAuthoring);
  }, isEqual);

  return (
    <div className="table-hierarchies-container">
      {tableHierarchies.map((h, idx: number) => (
        <TableHierarchyGroupings key={h.id} hierarchyIndex={idx} />
      ))}
      <div className="add-table-hierarchy-button">
        <AddHierarchyLink />
      </div>
    </div>
  );
};

export default TableHierarchySelector;
